import React, { useState } from 'react';
import './RegisterNewAccount.css';
import { useTranslation } from 'react-i18next';

function RegisterNewAccount() {
    const [showPrompt, setShowPrompt] = useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    const referral_code = urlParams.get("r");
    const { t } = useTranslation();
    const config = {
        personal: { "url": "https://app.bieases.com/login/signUp?r=" + referral_code },
        business: { "url": "https://merchant.bieases.com/login/signUp?r=" + referral_code }
    }

    const handleClick = async (e) => {
        try {
            e.preventDefault();
            setShowPrompt(true);
            return false;
        } catch (err) {
            console.error('Failed to show prompt: ', err);
        }
    };

    const handleOptionSelect = (type) => {
        if (type) {
            window.location.href = config[type].url;
        }
        setShowPrompt(false);
    };

    return (
        <>
            {referral_code && (
                <>
                    <div className="register-container">
                        <div className='title'>
                            {t('no_account_yet')}
                        </div>
                        <div className='title'>
                            <button href={'#'} onClick={handleClick}>{t('register_now')}</button>
                        </div>
                    </div>
                    {showPrompt && (
                        <div className='register-prompt' onClick={() => handleOptionSelect(null)}>
                            <div className='prompt-overlay'>
                                <div className='prompt-content'>
                                    <h3>{t('select_account_type')}</h3>
                                    <div className='prompt-options'>
                                        <button onClick={() => handleOptionSelect('personal')} className='option-button'>
                                            {t('personal')}
                                        </button>
                                        <button onClick={() => handleOptionSelect('business')} className='option-button'>
                                            {t('business')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default RegisterNewAccount;